import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { pallette } from "@/utils/colors";
// import { size } from "lodash";

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: pallette,
      }
    }
  },
  display: {
    mobileBreakpoint: "sm",
    thresholds: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400
    }
  },
  defaults: {
    VBtn: {
      color: "primary",
      variant: "flat"
    },
    VTextField: {
      variant: "outlined",
      density: "compact"
    },
    VSelect: {
      variant: "outlined"
    },
    VField: {
      color: "secondary"
    },
    VCheckbox: {
      color: "primary"
    }
  }
});
